import React, { useCallback } from 'react'
import { Drawer, Stack, IconButton } from '@mui/material'
import { Row } from '../components'
import Text from '@/components/Text'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'
import Button from '@/components/Button'
import { Copy } from '@/icon'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Message } from '@cx/ui'

export interface VoucherCodeProps {
  code: string
  onClose: () => void
}

const VoucherCode: React.FC<VoucherCodeProps> = (props) => {
  const { onClose, code } = props
  const theme = useTheme()

  const handleClose = useCallback(
    (event?: React.MouseEvent<HTMLElement>) => {
      event?.stopPropagation()
      event?.preventDefault()
      onClose && onClose()
    },
    [onClose],
  )

  const onCopy = useCallback(() => {
    Message.success('兑换码已复制到剪贴板')
  }, [])

  return (
    <Drawer
      sx={{ zIndex: theme.zIndex.drawer + 3 }}
      PaperProps={{
        sx: {
          boxShadow: '0px 4px 12px 0px rgba(0,0,0,0.2)',
          padding: '32px',
          backgroundColor: '#fff',
          borderLeft: 'none',
          overflow: 'hidden',
          width: '685px',
          flexDirection: 'column',
        },
      }}
      // @ts-ignore
      componentsprops={{
        backdrop: {
          style: { backgroundColor: 'rgba(0,0,0,0.2)' },
        },
      }}
      closeAfterTransition={true}
      disableRestoreFocus={true}
      anchor='right'
      open={!!code}
      // @ts-ignore
      onClose={handleClose}
    >
      <Row sx={{ marginBottom: '32px' }}>
        <Text weight='bold' size='md' sx={{ width: '100%' }}>
          兑换码
        </Text>
        <IconButton sx={{ borderRadius: '4px' }} onClick={handleClose}>
          <CloseIcon sx={{ fontSize: '16px', color: '#666666' }} />
        </IconButton>
      </Row>
      <Stack sx={{ gap: '8px', flex: 1, height: '85%' }}>
        <Row
          sx={{
            backgroundColor: '#F7F7F7',
            padding: '12px',
            gap: '24px',
            alignItems: 'flex-start',
          }}
        >
          <Text size='xs' sx={{ whiteSpace: 'break-spaces', flex: 1, lineBreak: 'anywhere' }}>
            {code ?? ''}
          </Text>
          <CopyToClipboard text={code} onCopy={onCopy}>
            <Copy sx={{ width: '14px' }} />
          </CopyToClipboard>
        </Row>
      </Stack>
      <Row sx={{ marginTop: 'auto', justifyContent: 'flex-end' }}>
        <Button type='secondary' onClick={handleClose}>
          确认
        </Button>
      </Row>
    </Drawer>
  )
}

export default VoucherCode
